import { sawEstateTtl } from "common/consts/sawEstates";
import Dexie, { Table } from "dexie";
import { useLiveQuery } from "dexie-react-hooks";
import { useEffect } from "react";

export interface SawEstate {
  key: string; // estateId#username
  estateId: string;
  username: string;
  createdAt: number;
}

class SawEstateDb extends Dexie {
  sawEstate!: Table<SawEstate>;

  constructor() {
    super("sawEstateDb");

    this.version(1).stores({
      sawEstate: "key, createdAt"
    });
  }
}

const sawEstateDb = new SawEstateDb();

export const saveSawEstate = async (
  estateId: string,
  username: string | undefined
) => {
  if (!username) {
    return;
  }

  const key = `${estateId}#${username}`;
  const createdAt = Date.now();
  await sawEstateDb.sawEstate.put({ key, estateId, username, createdAt });
};

const invokeListSawEstates = async (username: string | undefined) => {
  if (!username) {
    return [];
  }

  return await sawEstateDb.sawEstate
    .where("createdAt")
    .aboveOrEqual(Date.now() - sawEstateTtl)
    .and((x) => x.username === username)
    .toArray();
};

export const deleteSawEstate = async (
  estateId: string,
  username: string | undefined
) => {
  if (!username) {
    return;
  }

  const key = `${estateId}#${username}`;
  await sawEstateDb.sawEstate.delete(key);
};

export const clearExpiredSawEstate = async () => {
  await sawEstateDb.sawEstate
    .where("createdAt")
    .below(Date.now() - sawEstateTtl)
    .delete();
};

export const useSawEstate = (username: string | undefined) => {
  const sawEstates = useLiveQuery(
    async () => await invokeListSawEstates(username),
    [username]
  );

  useEffect(() => {
    const interval = setInterval(() => {
      clearExpiredSawEstate();
    }, 1000 * 10);

    return () => {
      clearExpiredSawEstate();
      clearInterval(interval);
    };
  }, []);

  return {
    sawEstates,
    sawEstatesAreLoading: sawEstates === undefined
  } as const;
};
